$(function () {

    const url = $("#sitenavnativeadvert").data("url");
    if (!url) return;

    $("#sitenavnativeadvert").load(url);

});